import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
import { RegistrationWithPlatformMember } from './RegistrationWithPlatformMember.js';
export class IDDeleteRegisterItem extends AutoEncoder {
    registrationId;
    /**
     * Per ten thousand of the registration price
     */
    cancellationFeePercentage = 0;
    hydrate(context) {
        for (const member of context.members) {
            const registration = member.patchedMember.registrations.find(r => r.id === this.registrationId);
            if (!registration) {
                continue;
            }
            return new DeleteRegisterItem({
                registration: new RegistrationWithPlatformMember({ registration, member }),
                cancellationFeePercentage: this.cancellationFeePercentage,
            });
        }
        throw new SimpleError({
            code: 'not_found',
            message: 'Registration not found',
            human: $t(`%qn`),
            field: 'deleteRegistrations',
        });
    }
}
__decorate([
    field({ decoder: StringDecoder })
], IDDeleteRegisterItem.prototype, "registrationId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 423 })
], IDDeleteRegisterItem.prototype, "cancellationFeePercentage", void 0);
export class DeleteRegisterItem {
    registration;
    /**
     * Per ten thousand of the registration price
     */
    cancellationFeePercentage;
    constructor(options) {
        this.registration = options.registration;
        this.cancellationFeePercentage = options.cancellationFeePercentage;
    }
    /**
     * Charges 100% if something was already paid, so the paid amount is not refunded by default
     */
    static defaultFor(registration) {
        const paid = registration.registration.balances.reduce((total, balance) => total + balance.amountPaid + balance.amountPending, 0);
        return new DeleteRegisterItem({
            registration,
            cancellationFeePercentage: paid > 0 ? 100_00 : 0,
        });
    }
    get id() {
        return this.registration.registration.id;
    }
    get cancellationFee() {
        return Math.round(this.registration.registration.calculatedPrice * this.cancellationFeePercentage / 10000);
    }
    clone() {
        return new DeleteRegisterItem({
            registration: this.registration.clone(),
            cancellationFeePercentage: this.cancellationFeePercentage,
        });
    }
    convert() {
        return IDDeleteRegisterItem.create({
            registrationId: this.id,
            cancellationFeePercentage: this.cancellationFeePercentage,
        });
    }
    validate() {
        if (this.cancellationFeePercentage > 100_00 || this.cancellationFeePercentage < 0) {
            throw new SimpleError({
                code: 'invalid_field',
                field: 'cancellationFeePercentage',
                message: 'Invalid cancellation fee percentage',
            });
        }
    }
}
//# sourceMappingURL=DeleteRegisterItem.js.map